export const isValidScheme = (u) => {
    return /^(https?:|mailto:|tel:)/i.test(u);
  };


export  const normalizeUrl = (u) => {
    if (!u) return null;
    let out = u.trim();
    if (!/^[a-zA-Z][a-zA-Z0-9+.\-]*:/.test(out)) {
      // no scheme -> assume https
      out = 'https://' + out;
    }
    if (!isValidScheme(out)) return null;
    try {
      // will throw on invalid URL
      new URL(out);
      return out;
    } catch (err) {
      return null;
    }
  };